import React, { useState } from 'react';
import { DarkSearchInput, DarkPopOver } from '../../../common';
import { TargetIcon } from '../../../../content/svg-component';

const FilterPanel = (props) => {
  const {
    searchKey,
    handleSearch,
    handleEmployeeSalesFilter,
    handleRoleFilter,
    employeeSalesOption,
    roleList,
  } = props;
  const [salesPopOver, setSalesPopOver] = useState(false);
  const [rolePopOver, setRolePopOver] = useState(false);
  return (
    <>
      <div className="d-flex employee-search-panel mb-4 mb-md-0 height-tab">
        <DarkSearchInput
          label="profile.employeesearch"
          className={`col-4 px-0`}
          name="searchKey"
          value={searchKey}
          onChange={handleSearch}
        />
        <DarkPopOver
          options={{
            data: employeeSalesOption,
            title: 'name',
            value: 'value',
            isMultiLanguage: false,
          }}
          icon={
            <TargetIcon
              color="#343a40"
              variant="svg-md-small svg-sm-small svg-xs-small svg-tiny"
            />
          }
          className={`col-4  px-0 employee-dropdown text-dark`}
          label="profile.employeeActivities"
          style="mt-2"
          handleChange={handleEmployeeSalesFilter}
          placement="center"
          labelClassName="text-truncate"
          isOpenAction={salesPopOver}
          DarkPopOverStatus={(e) => setRolePopOver(e)}
        />
        <DarkPopOver
          options={{
            data: roleList,
            title: 'name',
            value: 'id',
            isMultiLanguage: false,
          }}
          icon={
            <TargetIcon
              color="#343a40"
              variant="svg-md-small svg-sm-small svg-xs-small svg-tiny"
            />
          }
          className={`col-4 px-0  text-dark`}
          label="profile.employeeRole"
          style="mt-2"
          handleChange={handleRoleFilter}
          isOpenAction={rolePopOver}
          DarkPopOverStatus={(e) => {
            setSalesPopOver(e);
          }}
        />
      </div>
    </>
  );
};
export default FilterPanel;
